import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { RequisiteDeletePayload } from 'Interfaces/Requisite';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: RequisiteDeletePayload) =>
    $actions.requisite.deleteRequisite(dispatch, payload),
  );
};
